
import { MapLocation } from '@/types/location';

// Vidafit Gym Locations
export const vidafitGyms: MapLocation[] = [
  {
    id: 5001,
    name: "Vidafit - Riyadh (An Nafa)",
    type: "Gym",
    devices: 5,
    coordinates: [24.78302394853136, 46.662607639996615],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "18-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 5002,
    name: "Vidafit - Riyadh (Laban)",
    type: "Gym",
    devices: 1,
    coordinates: [24.641053591084113, 46.57111881078401],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "18-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 5003,
    name: "Vidafit - Riyadh (Ar Rawabi)",
    type: "Gym",
    devices: 3,
    coordinates: [24.68801932843155, 46.80014761288157],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "18-45",
    orientation: "Landscape",
    segment: "Fitness"
  }
];
